import React, { useState } from "react";
import { BBSyncFilterType } from "../models/DashboardModels";
import { Col, Row } from 'reactstrap';
import KDatePicker from "../components/KDatePicker";
import SearchBox from "../components/SearchBox";
import { MIN_DATE_REPORTS } from "../utils/Constant";
import moment from "moment";

interface ViewFilterProps {
    onApplyFilters: (viewFilter: BBSyncFilterType) => void;
}

export const BBSyncFailureFilters = ({
    onApplyFilters,
}: ViewFilterProps) => {

    const [viewFilter, setViewFilter] = useState<BBSyncFilterType>({
        dateFrom: undefined,
        dateTo: undefined,
        grievanceId: ''
    });

    const onResetFilter = () => {
        const resetFilter = {
            dateFrom: undefined,
            dateTo: undefined,
            grievanceId: ''
        };
        onApplyFilters(resetFilter);
        setViewFilter(resetFilter);
    };
    const currentYearStart = new Date(new Date().getFullYear(), 0, 1);
    const today = new Date();


    return (
        <div className="border rounded ps-3 pt-2 pe-3 pb-3 mb-3">
            <Row className="mb-3">
                <Col xs={6} md={3}>
                    <SearchBox
                        label="Search by Grievance ID"              
                        placeHolder="Ex. KGIG00000000068078"       
                        value={viewFilter.grievanceId || ''}        
                        onChange={(e: any) => {
                            const value = e.target.value;
                            const cleanedValue = value.replace(/[^a-zA-Z0-9]/g, '');

                            setViewFilter({
                                ...viewFilter,
                                grievanceId: cleanedValue
                            });
                        }}
                    />

                </Col>

                {/* DATE FROM */}
                <Col xs={6} md={3}>
                    <KDatePicker
                        label="Date From"
                        value={viewFilter.dateFrom}
                        minDate={currentYearStart}
                        maxDate={viewFilter.dateTo ?? today}
                        onChange={(date) => {
                            setViewFilter({
                                ...viewFilter,
                                dateFrom: date,
                            });
                        }}
                    />
                </Col>

                {/* DATE TO */}
                <Col xs={6} md={3}>
                    <KDatePicker
                        label="Date To"
                        value={viewFilter.dateTo}
                        minDate={viewFilter.dateFrom ?? currentYearStart}
                        maxDate={today}
                        onChange={(date) => {
                            setViewFilter({
                                ...viewFilter,
                                dateTo: date,
                            });
                        }}
                    />

                </Col>

            </Row>
            <Row>
                <Col className="d-flex gap-2">
                    <button
                        className="button"
                        onClick={() => {
                            onApplyFilters(viewFilter);
                        }}
                    >
                        Search
                    </button>

                    <button
                        className="resetButton"
                        onClick={onResetFilter}
                    >
                        Reset
                    </button>
                </Col>
            </Row>

        </div>
    );
};

export default BBSyncFailureFilters;